import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthContext } from "@/contexts/AuthContext";

/**
 * Clears React Query cache when the authenticated user changes.
 * Prevents stale cross-user/team data being displayed after logout/login.
 */
export function AuthQueryCacheBuster() {
  const { user } = useAuthContext();
  const queryClient = useQueryClient();
  const prevUserId = useRef<string | null>(null);

  useEffect(() => {
    const nextUserId = user?.id ?? null;

    if (prevUserId.current !== nextUserId) {
      // Clear all cached queries when user changes.
      queryClient.clear();
      prevUserId.current = nextUserId;
    }
  }, [user?.id, queryClient]);

  return null;
}
